import { COMPANION_MODE, PUBLIC } from 'router/routes';

const isPrivateRoute = (pathname: string) =>
    !Object.values({ ...PUBLIC, ...COMPANION_MODE }).find(({ path }) => path === pathname);

export default isPrivateRoute;
